import { LoadingOutlined } from "@ant-design/icons";
import { Button, Form, Input, Modal, Spin } from "antd";
import React, { useState } from "react";
import EditScaleNameApi from "../../../api/scales/EditScaleNameApi";
import {
  openNotificationError,
  openNotificationSuccess,
} from "../../../helpers/NotificationHelpers";

function EditScaleNameModal(props) {
  const [submit, setSubmit] = useState(false);
  const [valuesChanged, setValuesChanged] = useState(false);

  function handleCancel() {
    setSubmit(false);
    props.handleCancel();
    setValuesChanged(false);
  }

  async function onFinish(values) {
    setSubmit(true);
    const apiResponse = await EditScaleNameApi(props.scale?.id, values.name);

    if (apiResponse.error) {
      openNotificationError("bottomRight", apiResponse.message);
    } else if (apiResponse.success) {
      openNotificationSuccess("bottomRight", "Scale name edited successfully");
      props.handleOk();
    } else {
      openNotificationError(
        "bottomRight",
        "Couldn't edit scale name. Try again later."
      );
    }
    handleCancel();
  }

  return (
    <Modal
      title="Edit scale name"
      visible={props.visible}
      onCancel={() => handleCancel()}
      footer={null}
      destroyOnClose={true}
    >
      <Form
        name="scaleName"
        onFinish={onFinish}
        autoComplete="off"
        layout="vertical"
        requiredMark={false}
        initialValues={{ name: props.scale?.name }}
        onValuesChange={() => {
          setValuesChanged(true);
        }}
      >
        <Form.Item
          label="Scale name"
          name="name"
          rules={[{ required: true, message: "Please enter a scale name!" }]}
        >
          <Input placeholder="name" />
        </Form.Item>

        <Form.Item style={{ marginBottom: 0 }}>
          <div className=" flex justify-end">
            <Button className="mr-3" onClick={() => handleCancel()}>
              Cancel
            </Button>
            <Button
              className="btn w-28"
              type="primary"
              htmlType={submit && "submit"}
              disabled={submit || !valuesChanged}
            >
              {submit ? (
                <Spin
                  size="small"
                  indicator={<LoadingOutlined style={{ color: "#fff" }} spin />}
                />
              ) : (
                "Save"
              )}
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default EditScaleNameModal;
